var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEmptyHexagon = function SvgEmptyHexagon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 211,
    height: 389
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#F17900",
    strokeWidth: 31,
    d: "M219.476 375.072 48.922 312.996 17.404 134.253 156.441 17.587l170.555 62.077 31.517 178.742z",
    opacity: 0.102
  })));
};
export default SvgEmptyHexagon;